import React, { useEffect } from "react";
import CheckRateform from "./CheckRateform";
import ComparisonSection from "./ComparisonSection";
import FaqSection from "./FaqSection";
import HeroSection from "./HeroSection";
import HowMinemiWorks from "./HowMinemiWorks";
import TestimonialsSection from "./TestimonialsSection";
import WhyCheckRate from "./WhyCheckRate";
import { Helmet } from "react-helmet-async";

export default function CheckRate() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen" style={{ backgroundColor: "#f8f8f8" }}>
      <Helmet>
        <title>Compare Loan Interest Rates - Minemi</title>
      </Helmet>
      <HeroSection />
      <CheckRateform />
      <WhyCheckRate />
      <HowMinemiWorks />
      <ComparisonSection />
      <TestimonialsSection />
      <FaqSection />
    </div>
  );
}
